import { Col, Collapse, Row, Select } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import { useEmployees } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useDocumentTypes } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';

const DirectSaleXFinancialMoreOptions: React.FC = () => {
  const { Panel } = Collapse;
  const intl = useIntl();

  const { data: employeesData, isFetching: isFetchingEmployees } =
    useEmployees();
  const { data: documentsTypesData, isFetching: isFetchingDocumentsTypes } =
    useDocumentTypes();

  const employees = flatInfiniteData(employeesData);
  const documentTypes = flatInfiniteData(documentsTypesData);
  return (
    <Col sm={24}>
      <Collapse accordion>
        <Panel
          header={intl.formatMessage({
            id: 'movementDirectSaleXFinancial.form.moreOptions',
          })}
          key={1}
        >
          <Row gutter={[24, 24]}>
            <Col sm={12}>
              <FloatingFormItem
                name="employeesIds"
                label={intl.formatMessage({
                  id: 'movementDirectSaleXFinancial.form.moreOptions.employee',
                })}
              >
                <Select
                  allowClear
                  mode="multiple"
                  loading={isFetchingEmployees}
                  style={{ width: '100%' }}
                  options={employees?.map((employee) => ({
                    value: employee.id,
                    label: employee.name,
                  }))}
                ></Select>
              </FloatingFormItem>
            </Col>

            <Col sm={12}>
              <FloatingFormItem
                name="documentTypesIds"
                label={intl.formatMessage({
                  id: 'movementDirectSaleXFinancial.form.moreOptions.documentTypes',
                })}
              >
                <Select
                  allowClear
                  mode="multiple"
                  loading={isFetchingDocumentsTypes}
                  style={{ width: '100%' }}
                  options={documentTypes?.map((documentType) => ({
                    value: documentType.id,
                    label: documentType.description,
                  }))}
                ></Select>
              </FloatingFormItem>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </Col>
  );
};

export default DirectSaleXFinancialMoreOptions;
